module.exports = __webpack_public_path__ + "img/account-details.06169815.svg";